var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.664 74.3357C30.3329 74.3357 25.9961 78.6725 25.9961 84.0036V87.2263H58.2226V84.0036C58.2226 78.6725 53.8858 74.3357 48.5546 74.3357H35.664Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1094 61.4453C47.4488 61.4453 51.7773 57.1168 51.7773 51.7773C51.7773 46.4379 47.4488 42.1094 42.1094 42.1094C36.7699 42.1094 32.4414 46.4379 32.4414 51.7773C32.4414 57.1168 36.7699 61.4453 42.1094 61.4453Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5508 84.0038C19.5508 75.1194 26.7796 67.8905 35.664 67.8905H42.1093C33.2249 67.8905 25.9961 60.6617 25.9961 51.7773C25.9961 42.8929 33.2249 35.664 42.1093 35.664C50.9937 35.664 58.2225 42.8929 58.2225 51.7773C58.2225 60.6617 50.9937 67.8905 42.1093 67.8905H48.5546C57.439 67.8905 64.6678 75.1194 64.6678 84.0038V87.2264H103.34V35.664H79.0785L58.2225 46.0936V22.7734H6.44531V87.2264H19.5508V84.0038Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 96.8943C0 102.234 4.32845 106.562 9.66795 106.562H100.117C105.456 106.562 110 102.234 110 96.8943V93.6716H0V96.8943Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6677 35.664L77.5583 29.2187H110V3.4375H64.6677V35.664ZM96.8942 13.1054H103.34V19.5507H96.8942V13.1054ZM84.0036 13.1054H90.4489V19.5507H84.0036V13.1054ZM71.113 13.1054H77.5583V19.5507H71.113V13.1054Z",
    fill: "#BAE3F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31);
export default __webpack_public_path__ + "static/media/Group-31.813e9192902c9a950fa3a2963664fc74.svg";
export { ForwardRef as ReactComponent };